{
  "instances": {
    "sessions": {
      "label": "Sitzungen",
      "attributes": "Attribute",
      "created_at": "Erstellt am",
      "expired": "Abgelaufen",
      "expiry": "Verfällt",

      "last_accessed_at": "Letzter Zugriff",
      "loading_sessions": "Sitzungen laden...",
      "max_inactive_interval": "Max. Inaktivitäts-<br>intervall",
      "no_sessions_found": "Keine Sitzungen gefunden",
      "session_id": "Session Id",
      "unlimited": "Unendlich"
    }
  }
}
